// export default ProgressBar;
import React, { useContext, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { API_BASE_URL } from "../../global";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { StoreContext } from "../../context/Store";

const ProgressBar = ({
  handleContinueClick,
  allCasedata,
  handlesupplementClick,
  handleaddagentClick,
  handleaddagentassistantClick,
  handleaddadditionalappsClick,
}) => {
  const progressRefs = useRef([]);
  const caseData = {
    message: allCasedata,
  };

  const { showPdfLinkView, setShowPdfLinkView } = useContext(StoreContext);

  useEffect(() => {
    progressRefs.current.forEach((circleContainer) => {
      if (!circleContainer) return;

      const percent = parseInt(
        circleContainer.getAttribute("data-percentage"),
        10,
      );
      const progressValue = circleContainer.querySelector(".progress-value");
      const progressText = circleContainer.querySelector(".progress-text");

      const radius = 15;
      const circumference = 2 * Math.PI * radius;
      const offset = circumference - (percent / 100) * circumference;

      let color = "#f7374f"; // red
      if (percent > 80)
        color = "#42b966"; // green
      else if (percent > 50) color = "#feba17"; // yellow

      if (progressValue) {
        progressValue.style.stroke = color;
        progressValue.style.strokeDasharray = circumference;
        progressValue.style.strokeDashoffset = offset;
        progressValue.style.strokeLinecap = "round";
        progressValue.style.transition =
          "stroke-dashoffset 0.5s ease, stroke 0.5s ease";
      }

      if (progressText) {
        progressText.textContent = `${percent}%`;
      }
    });
  }, [caseData]);

  const handleview = (item) => {
    setShowPdfLinkView({
      range: null,
      show: false,
    });
    //if(item.caseStatus && item.caseStatus.length > 0 && item.caseStatus[0] == '100%'){
    localStorage.setItem("caseID", item.caseId);
    window.dispatchEvent(new Event("caseIDUpdated"));
    handleContinueClick();
    // }else{
    //   toast.error(`Sorry, this case is still processing. Please try again once it's completed.`);
    // }
  };

  function randomPrefix() {
    return Math.floor(100 + Math.random() * 900); // 3-digit number between 100 and 999
  }
  const downloadpdf = async (
    url,
    caseName = "Original_document",
    case_id = "1",
  ) => {
    const pdfUrl = url;

    try {
      const response = await axios.post(
        `${API_BASE_URL}download_pdf`,
        { pdf_url: pdfUrl },
        {
          responseType: "blob", // Important to get binary data
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const pdfBlob = response.data;

      const now = new Date();
      const pad = (n) => String(n).padStart(2, "0");

      const zip = new JSZip();
      const pdffileName = `${randomPrefix()}${case_id}${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
      zip.file(`${pdffileName}.pdf`, pdfBlob);
      const zipBlob = await zip.generateAsync({ type: "blob" });

      const fileName = `${randomPrefix()}${case_id}${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
      saveAs(zipBlob, `${fileName}.zip`);
    } catch (err) {
      console.error("Error downloading and zipping PDF:", err);
      window.open(pdfUrl, "_blank"); // Fallback to open directly
    }
  };

  return (
    <div className="recent-tab text-disapper">
      <div
        className="progress-wrapper"
        style={{ height: "calc(100vh - 357px)" }}
      >
        <div className="progress-list d-flex flex-column">
          {[...caseData.message]
            .sort((a, b) => new Date(b.created_on) - new Date(a.created_on)) // Sort newest to oldest
            .map((item, index) => {
              const percent = parseInt(item.caseStatus?.[0] || 0);
              //const date = new Date(item.created_on).toLocaleString();
              const date = item.caseCreated || "";

              return (
                <div
                  key={item.caseId}
                  className="d-flex align-items-center justify-content-between gap-2 py-2"
                  ref={(el) => (progressRefs.current[index] = el)}
                  data-percentage={percent}
                >
                  <div
                    className="d-flex align-items-center flex-grow-1 overflow-hidden"
                    style={{ width: "90%" }}
                  >
                    <div className="progress-circle" data-percentage={percent}>
                      <svg width="40" height="40" viewBox="0 0 40 40">
                        <circle
                          className="progress-bg"
                          cx="20"
                          cy="20"
                          r="15"
                          stroke="#eee"
                          strokeWidth="4"
                          fill="none"
                        />
                        <circle
                          className="progress-value"
                          cx="20"
                          cy="20"
                          r="15"
                          strokeWidth="4"
                          fill="none"
                        />
                      </svg>
                      <div className="progress-text">0</div>
                    </div>
                    <div className="case-info flex-grow-1">
                      <h6>{item.caseName}</h6>
                      <span>{date}</span>{" "}
                      <span style={{ fontSize: "9px" }}>
                        (
                        {item?.caseServiceData?.[0]?.serviceName || "Paralegal"}
                        )
                      </span>
                    </div>
                  </div>
                  <div className="ru-exten" style={{ width: "10%" }}>
                    <button
                      className="dropdown-toggle"
                      data-bs-toggle="dropdown"
                      type="button"
                    >
                      <i className="fa-solid fa-ellipsis text-dark"></i>
                    </button>
                    <div className="dropdown-menu dropdown-menu-end">
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          handleview(item);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <i className="fa fa-eye me-1"></i> View
                      </a>

                      {item.pdf_url ? (
                        // <a className="dropdown-item" href={item.pdf_url} download target="_blank" rel="noopener noreferrer" >
                        // <i className="fa fa-download me-1"></i> Download
                        // </a>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            downloadpdf(
                              item.pdf_url,
                              item.caseName,
                              item.caseId,
                            );
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <i className="fa fa-download me-1"></i> Download
                        </a>
                      ) : null}

                      {percent === 100 ? (
                        <>
                          <a
                            className="dropdown-item"
                            onClick={() => {
                              handlesupplementClick(item);
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <i className="fa fa-file me-1"></i> Add supplement
                          </a>
                          {item?.caseServiceData?.[0]?.serviceAgentsCount
                            ?.summaryAgentsCount > 0 && (
                            <a
                              className="dropdown-item"
                              onClick={() => {
                                handleaddagentClick(item);
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <i className="fa fa-id-badge me-1"></i> Add
                              summary agents
                            </a>
                          )}
                          {item?.caseServiceData?.[0]?.serviceAgentsCount
                            ?.assistantAgentCount > 0 && (
                            <a
                              className="dropdown-item"
                              onClick={() => {
                                handleaddagentassistantClick(item);
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <i className="fa fa-id-badge me-1"></i> Add agents
                              assistant
                            </a>
                          )}
                          {item?.caseServiceData?.[0]?.serviceAgentsCount
                            ?.appAgentsCount > 0 && (
                            <a
                              className="dropdown-item"
                              onClick={() => {
                                handleaddadditionalappsClick(item);
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <i className="fa fa-id-badge me-1"></i> Add
                              AttestaAI agents
                            </a>
                          )}
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
